import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { NOTION_DIALOG_PAPER_SX } from '@/shared/styles/dialogStyles'
import { RADIUS } from '@/shared/styles/radii'

import { type RecordingImage } from './recordingImageApi'

interface Props {
  // 開いている写真 (null で閉じる)
  image: RecordingImage | null
  onClose: () => void
}

// 写真の拡大だけの dialog。種別と削除は行にあるので置かない。PDF は通さない (新しいタブで開く。openPdf)。
// (nasu-patient-app-front ImagePreviewDialog を yakureki-front latest の token に合わせて移植)
export const AttachmentPreviewDialog = ({ image, onClose }: Props) => (
  <Dialog
    open={image !== null}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    slotProps={{ paper: { sx: NOTION_DIALOG_PAPER_SX } }}
  >
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      {/* DialogTitle が h2 なので、中は見出し要素にしない (h6 を h2 に入れない) */}
      <Typography
        component="span"
        variant="subtitle2"
        sx={{ fontWeight: 600 }}
        noWrap
      >
        添付資料
      </Typography>
      <IconButton
        onClick={onClose}
        size="small"
        aria-label="閉じる"
        sx={{
          color: colorTokens.fg.muted,
          '&:hover': { backgroundColor: colorTokens.bg.muted },
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ display: 'flex', justifyContent: 'center', pt: 1 }}>
      {image && (
        <Box
          component="img"
          src={image.image}
          alt="添付資料"
          sx={{
            maxWidth: '100%',
            maxHeight: '70vh',
            objectFit: 'contain',
            borderRadius: `${RADIUS.md}px`,
          }}
        />
      )}
    </DialogContent>
  </Dialog>
)
